export enum DatexStatus {
	Pending,
	Exported,
	Imported,
	Cancelled
}